if (!customElements.get('elunori-creator-carousel')) {
  class ElunoriCreatorCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-el-creator-track]');
      this.previousButton = this.querySelector('[data-el-creator-prev]');
      this.nextButton = this.querySelector('[data-el-creator-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.onPrevious = () => this.scrollCards(-1);
      this.onNext = () => this.scrollCards(1);
      this.onScroll = () => this.updateButtons();

      this.previousButton.addEventListener('click', this.onPrevious);
      this.nextButton.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.updateButtons();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.previousButton.removeEventListener('click', this.onPrevious);
      this.nextButton.removeEventListener('click', this.onNext);
      this.track.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    scrollCards(direction) {
      const card = this.track.querySelector('.el-creator-card');
      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    updateButtons() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previousButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
    }
  }

  customElements.define('elunori-creator-carousel', ElunoriCreatorCarousel);
}
